function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useContext } from 'react';
import { connect } from 'react-redux';
import { cmsActions } from '../../../reducers/cms.reducer';
import UserData from './User.context';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import CardBody from '../../common/card/CardBody.react';
import Button from '../../common/Button.react';
import Label from '../../common/form/Label.react';
import Input from '../../common/form/Input.react';

// TODO :: remove blankspace in password
var UserPassword = function UserPassword(_ref) {
  var usersAction = _ref.usersAction;
  var _useContext = useContext(UserData),
    _useContext2 = _slicedToArray(_useContext, 1),
    state = _useContext2[0];
  var userID = state.userID;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    password = _useState2[0],
    setPassword = _useState2[1];
  var isValid = function isValid() {
    return password.length > 0;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Change Password"
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Label, {
    label: "New Password",
    required: true
  }), /*#__PURE__*/React.createElement(Input, {
    value: password,
    onChange: function onChange(e) {
      return setPassword(e.target.value);
    },
    permission: "edit-users"
  }), /*#__PURE__*/React.createElement("div", {
    className: "a__btns"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Random",
    permission: "edit-users",
    onClick: function onClick() {
      setPassword(Math.random().toString(36).slice(-8));
    }
  }), /*#__PURE__*/React.createElement(Button, {
    label: "Update",
    onClick: function onClick() {
      usersAction({
        formData: {
          password: password,
          userID: userID
        },
        method: 'put',
        route: 'update-password'
      });
      setPassword('');
    },
    disabled: !isValid(),
    permission: "edit-users"
  })))));
};
var mdtp = {
  usersAction: cmsActions.users
};
export default connect(null, mdtp)(UserPassword);